export default {
    name: '職務権限名',
    sortno: '並び順',
    permissionsetting: '権限設定'
};
